





























































































































import { mapFields } from 'vuex-map-fields';
import NoUISlider from '@/components/NoUISlider.vue'
import ToggleThreeState from '@/components/ToggleThreeState.vue'

export default
    components: { NoUISlider, ToggleThreeState }

    methods:
        getRangeConfig: (name) ->
            range = @$store.state.filter.range[name]
            cfg =
                animate: false
                connect: true
                tooltips: true
                step: range.step
                # pips:
                #     mode: 'values'
                #     values: [1..10]
                #     density: 10
                range:
                    min: range.lower_bound
                    max: range.upper_bound
                format:
                    to: (value) ->
                        return value.toFixed(1)
                    from: (value) ->
                        return Number(value)
            return cfg

        setRange: (name, values) ->
            @$store.commit 'filter/SET_RANGE',
                name: name
                min: values[0]
                max: values[1]

    computed: {
        ...mapFields('filter', {
            'in_collection'
            'seen'
            'reviewed'
            'released'
            'hidden'
            imdb_score_min: 'range.imdb_score.min'
            imdb_score_max: 'range.imdb_score.max'
            imdb_votes_min: 'range.imdb_votes.min'
            imdb_votes_max: 'range.imdb_votes.max'
            metacritic_score_min: 'range.metacritic_score.min'
            metacritic_score_max: 'range.metacritic_score.max'
            year_min: 'range.year.min'
            year_max: 'range.year.max'
            runtime_min: 'range.runtime.min'
            runtime_max: 'range.runtime.max'
            imdb_last_check_time_min: 'range.imdb_last_check_time.min'
            imdb_last_check_time_max: 'range.imdb_last_check_time.max'
        })

        imdb_score:
            get: ->
                return [@imdb_score_min, @imdb_score_max]
            set: (values) ->
                @setRange('imdb_score', values)
        imdb_votes:
            get: ->
                return [@imdb_votes_min, @imdb_votes_max]
            set: (values) ->
                @setRange('imdb_votes', values)
        metacritic_score:
            get: ->
                return [@metacritic_score_min, @metacritic_score_max]
            set: (values) ->
                @setRange('metacritic_score', values)
        year:
            get: ->
                return [@year_min, @year_max]
            set: (values) ->
                @setRange('year', values)
        runtime:
            get: ->
                return [@runtime_min, @runtime_max]
            set: (values) ->
                @setRange('runtime', values)
        imdb_last_check_time:
            get: ->
                return [@imdb_last_check_time_min, @imdb_last_check_time_max]
            set: (values) ->
                @setRange('imdb_last_check_time', values)
    }

